import React from 'react';
import ViewGame from '../../components/games/components/view-game';

const ViewGameContainer = () => {
    return <ViewGame />;
};

export default ViewGameContainer;
